import AppDetailContent from '../components/AppDetail/AppDetailContent';

const HomePage = () => {
  return <AppDetailContent />;
};

export default HomePage;